import { Lang, RewardOption as RawOption, RewardOptionValue } from '@owl-nest/api-client/latest'

import * as i18n from './i18n'
import * as rewardModel from './reward'

export type Option<PROJECT_EXTRA_FIELDS extends string = ''> = RawOption & {
  parent: rewardModel.Reward<PROJECT_EXTRA_FIELDS>
}

export function Option<PROJECT_EXTRA_FIELDS extends string = ''>(
  option: RawOption,
  parent: rewardModel.Reward<PROJECT_EXTRA_FIELDS>,
): Option<PROJECT_EXTRA_FIELDS> {
  return { ...option, parent }
}

/**
 * Returns the option description if available. Either in the user's locale, or in the project language if the former is empty.
 * @param option
 */
export function description(option: Option): string | undefined {
  if (!option.description) {
    return
  }
  return i18n.get(option.description, option.parent.project?.lang as Lang, '')
}

/**
 * Returns the option name in the user's locale. If none, falls back to the project language.
 * @param option
 */
export function name(option: Option): string | undefined {
  return i18n.get(option.name, option.parent.project?.lang as Lang, '')
}

/**
 * Returns the option value name in the user's locale. If none, falls back to the project language.
 * @param optionValue
 * @param option
 */
export function valueDescription(optionValue: RewardOptionValue, option: Option) {
  return i18n.get(optionValue.name, option.parent.project?.lang as Lang, '')
}
